import Icon from '@/common/components/Icon';

export const getHeadersArray = (isFinal, reloadData) => [
	[
		<th colSpan={6}>
			<span>{isFinal ? 'Final result ' : 'Pre result '}</span>
			<Icon name={'arrow-right-arrow-left'} onClick={reloadData} style={{position: 'absolute', top: '1rem', right: '1rem', fontSize: 'large', color: '#fff', cursor: 'pointer'}}/>
		</th>,
	],
	[
		<th>Price</th>,
		<th>For one</th>,
		<th>Confirmed orders</th>,
		<th>Delivered orders</th>,
		<th>Bonus-eligible orders</th>,
		<th>Effective payment</th>,
	],
];
